﻿export function dateDiff(date1, date2) {
    var datediff = date1.getTime() - date2.getTime(); //store the getTime diff - or +
    //return (datediff / (24 * 60 * 60 * 1000)); //Convert values to -/+ days and return value      
    return (datediff / (60 * 60 * 1000)); //Convert values to -/+ hours and return value      
}

export function dateFromStrLocal(dtStr) {
    var returnDate;
    var parts = dtStr.split("-");
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var parts2 = parts[2].split(" ");
    var day = parseInt(parts2[0], 10);
    var parts3 = parts2[1].split(":");
    var hour = parseInt(parts3[0], 10);
    var minute = parseInt(parts3[1], 10);
    returnDate = new Date(year, month - 1, day, hour, minute);
    return returnDate;
}

export function dateFromStr(dtStr, inputFormat, isNotUTC) {
    //new Date(year,month,date[,hour,minute,second,millisecond ])
    //1.year: Integer value representing the year. For compatibility (in order to avoid the Y2K problem), you should always specify the year in full; use 1998, rather than 98.
    //2.month: Integer value representing the month, beginning with 0 for January to 11 for December. 
    //3.date: Integer value representing the day of the month.
    //4.hour: Integer value representing the hour of the day (24-hour scale).
    //5.minute: Integer value representing the minute segment of a time reading.
    //6.second: Integer value representing the second segment of a time reading.
    //7.millisecond: Integer value representing the millisecond segment of a time

    var returnDate;
    switch (inputFormat) {
        case "dd/MM/yyyy hh:mm:ss TT":
            {
                var parts = dtStr.split("/");
                var day = parseInt(parts[0], 10);
                var month = parseInt(parts[1], 10);
                var parts2 = parts[2].split(" ");
                if (parts2.length > 1) {
                    var year = parseInt(parts2[0], 10);
                    TT = parts2[2];
                    var parts3 = parts2[1].split(":");
                    var hour = parseInt(parts3[0], 10);
                    if (TT == "PM") {
                        hour = hour + 12;
                    }
                    var minute = parseInt(parts3[1], 10);
                    if (isNotUTC) {
                        returnDate = new Date(year, month - 1, day, hour, minute);
                    } else {
                        returnDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
                    }

                } else {
                    if (isNotUTC) {
                        returnDate = new Date(year, month - 1, day, 0, 0);
                    } else {
                        returnDate = new Date(Date.UTC(year, month - 1, day, 0, 0));
                    }

                }
                break;
            }
        case "yyyy-MM-dd hh:mm:ss":
            {
                var parts = dtStr.split("-");
                var year = parseInt(parts[0], 10);
                var month = parseInt(parts[1], 10);
                var parts2 = parts[2].split(" ");
                var day = parseInt(parts2[0], 10);
                var parts3 = parts2[1].split(":");
                var hour = parseInt(parts3[0], 10);
                var minute = parseInt(parts3[1], 10);
                if (isNotUTC) {
                    returnDate = new Date(year, month - 1, day, hour, minute);
                } else {
                    returnDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
                }

                break;
            }
        case "yyyy-MM-ddThh:mm:ss.xx":
            {
                var parts = dtStr.split("-");
                var year = parseInt(parts[0], 10);
                var month = parseInt(parts[1], 10);
                var parts2 = parts[2].split("T");
                var day = parseInt(parts2[0], 10);
                var parts3 = parts2[1].split(":");
                var hour = parseInt(parts3[0], 10);
                var minute = parseInt(parts3[1], 10);
                if (isNotUTC) {
                    returnDate = new Date(year, month - 1, day, hour, minute);
                } else {
                    returnDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
                }

                break;
            }
        case "epoch":
            // Millis from Epoch
        default:
            returnDate = new Date(dtStr);
    }
    return returnDate;
}

export function dateParse(dtStr, inputFormat, outputFormat) {
    var returnDate;
    returnDate = dateFromStr(dtStr, inputFormat);
    return dateToString(returnDate, outputFormat);
}

export function dateToString(returnDate, outputFormat) {
    var curr_year = returnDate.getFullYear();
    var curr_day = returnDate.getDay();
    var curr_date = returnDate.getDate();
    var curr_month = returnDate.getMonth() + 1; //Months are zero based
    switch (outputFormat) {
        case "ddd":
            {
                return dayOfWeek(curr_day).substring(0, 3);
            }
        case "ddd hh:mm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return dayOfWeek(curr_day).substring(0, 3) + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "hh:mm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "dddd":
            {
                return dayOfWeek(curr_day);
            }
        case "ddd, dd/MM":
            {
                return (dayOfWeek(curr_day)).substring(0, 3) + ", " + curr_date.toString() + "/" + curr_month;
            }
        case "ddd, MMM dd":
            {
                return (dayOfWeek(curr_day)).substring(0, 3) + ", " + (monthOfYear(curr_month)).substring(0, 3) + " " + curr_date.toString();
            }
        case "MMM dd":
            {
                return (monthOfYear(curr_month)).substring(0, 3) + " " + curr_date.toString();
            }
        case "ddd, MMM dd hh:mm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return (dayOfWeek(curr_day)).substring(0, 3) + ", " + (monthOfYear(curr_month)).substring(0, 3) + " " + curr_date.toString() + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "dddd, MMMM dd, yyyy":
            {
                return dayOfWeek(curr_day) + ", " + monthOfYear(curr_month) + " " + curr_date.toString() + ", " + curr_year.toString();
            }
        case "ddd, dd MMMM yyyy hh:mm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return (dayOfWeek(curr_day)).substring(0, 3) + ', ' + curr_date.toString() + ' ' + monthOfYear(curr_month) + ' ' + curr_year.toString() + '&nbsp;&nbsp;' + pad(curr_hour, 2) + ':' + pad(curr_min, 2);
            }
        case "yyyyMMdd":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return curr_year.toString() + pad(curr_month, 2) + pad(curr_date, 2);
            }
        case "yyyyMMddhhmm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return curr_year.toString() + pad(curr_month, 2) + pad(curr_date, 2) + pad(curr_hour, 2) + pad(curr_min, 2);
            }
        case "hh":
            {
                var curr_hour = returnDate.getHours();
                return pad(curr_hour, 2);
            }
        case "dd/MM hh:mm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return curr_date.toString() + "/" + curr_month + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
        case "dd/MM/YYYY hh:mm":
            {
                var curr_hour = returnDate.getHours();
                var curr_min = returnDate.getMinutes();
                return curr_date.toString() + "/" + curr_month + "/" + curr_year.toString() + " " + pad(curr_hour, 2) + ":" + pad(curr_min, 2);
            }
    }
    return returnDate.toString();
}

export function dayOfWeek(dd) {
    if (dd > 6) { dd = dd - 7 };
    switch (dd) {
        case 0:
            {
                return "Sunday";
            }
        case 1:
            {
                return "Monday";
            }
        case 2:
            {
                return "Tuesday";
            }
        case 3:
            {
                return "Wednesday";
            }
        case 4:
            {
                return "Thursday";
            }
        case 5:
            {
                return "Friday";
            }
        case 6:
            {
                return "Saturday";
            }
    }
    return "undefined";
}

export function monthOfYear(MM) {
    switch (MM) {
        case 1:
            {
                return "January";
            }
        case 2:
            {
                return "February";
            }
        case 3:
            {
                return "March";
            }
        case 4:
            {
                return "April";
            }
        case 5:
            {
                return "May";
            }
        case 6:
            {
                return "June";
            }
        case 7:
            {
                return "July";
            }
        case 8:
            {
                return "August";
            }
        case 9:
            {
                return "September";
            }
        case 10:
            {
                return "October";
            }
        case 11:
            {
                return "November";
            }
        case 12:
            {
                return "December";
            }
    }
    return "undefined";
}

export function pad(num, size) {
    var s = "00" + num;
    return s.substring(s.length - size);
}

export function localize(t) {
    //var offset = new Date().getTimezoneOffset();

    // Get the offset in ms
    var offset = t.getTimezoneOffset() * 60000;

    // Subtract from the UTC time to get local
    t.setTime(t.getTime() - offset);



    //var d = new Date.parse(t.toString() + " UTC");
    //var d = new Date.parse(t.toString());
    //return d;
    return t;
}


export function dteParse(inpStr) {
    inpStr = inpStr.replace(/'/g, '');
    return dateFromStr(inpStr, 'yyyy-MM-dd hh:mm:ss');
}


//utility method to get the min or max value from an array
//param arr: input array
//param propname: object property to retrieve (must be numeric)
//param min or max as string lowercase
//returns bounding value of array
export function getArrayBound(arr, propName, minOrMax) {
    var boundObj;
    if (minOrMax === 'max') {
        boundObj = _.max(arr, function(item) { return eval('Number(item.' + propName + ')'); });
    } else {
        boundObj = _.min(arr, function(item) { return eval('Number(item.' + propName + ')'); });
    }
    return boundObj[propName];
}